export default __webpack_public_path__ + "static/media/SG-White-0000.a17f4fc1.png";